import React,
{
	// useState,
	useEffect,
	useRef,
} from 'react'
import PropTypes from 'prop-types'
import {v4 as uuid} from 'uuid'
import { useState } from 'react'
import Parser from 'html-react-parser';


import NumberFormat from 'react-number-format';

// hook
import useWindowSize from '../../../../Hooks/useWindowSize'

// Mol
import Modal, { ModalSize } from '../../Modal'
import MSolicitarPartModal from '../../Modal/Part/MSolicitar'
import MModCompraPartModal from '../../Modal/Part/MModCompra'


function PlayComPlanCardMol(props) {
	const {
		item,
		refHead,
		refPrice,
		itemsHeadRef,
		itemsPriceRef,
		onClickDelete,
		// heigthHead,
		// heigthPrice
	}= props

	const {
		exelentFor,
		fc_TEXTO_CAJA,
		fc_COLOR_CAJA,
		fc_NOMBRE,
		fc_DESCRIPCION,
		fc_ETIQUETA_PERIODO,
		//fi_PRECIO_PLAN,
		fc_DESCRIPCION_OFERTA,
		fc_ETIQUETA_PRECIO_TACHADO,
		//fc_PRECIO_TACHADO,
		fc_NOTA_DEBAJO_PRECIO,
		fc_TEXTO_CONTRATAR,
		fc_OPCION_CONTRATACION,
		fc_URL_CONTRATAR,
		fc_TARGET_CONTRATAR,
		fc_CRC,
		fc_TITULO_PROMO,
		fi_SERVICIO,
		fi_PLAN,
		lstPlanContratacionxPlan,
		Caracteristicas,
		caracteristicasPromocion,
		optionsCiudadesLogic
	} = item

	const familiaLoc = localStorage.getItem("id_familia")
    const  ciudadId = localStorage.getItem("ciudad")
    const estratoId = localStorage.getItem("estrato")

	function getCalculateEstrato(item){
        
        if(familiaLoc !== 'SHO'){
            return item
        }
        if(ciudadId !== '-1' && estratoId !== '-1'){
            let estratoItem = item.lstEstratosxPlan?.find(e => e.fi_ESTRATO.toString() === estratoId.toString())
            return estratoItem ? estratoItem : item
        } else {
            return item
        }
    }

	let itemEstrato = getCalculateEstrato(item)

	const fi_PRECIO_PLAN= ciudadId !== '-1' && estratoId !== '-1' ? itemEstrato.fi_PRECIO_PLAN : item.fi_PRECIO_PLAN;
	const fc_PRECIO_TACHADO= ciudadId !== '-1' && estratoId !== '-1' ? itemEstrato.fc_PRECIO_TACHADO : item.fc_PRECIO_TACHADO;

	console.log("entrooo",item)
	const {
        width: widthWindos, 
        // height: wheightWindos, 
    } = useWindowSize()

	const [heigthHead, setHeigthHead] = useState(0)
	const [heigthPrice, setHeigthPrice] = useState(0)

    // const {
    //     width: widthWindos, 
    //     // height: wheightWindos, 
    // } = useWindowSize()
	
	const minHeightForHead = () => {
		// console.group("Head")
		// console.log("Elementos Head", itemsHeadRef)
		// console.log("Elementos Head current", itemsHeadRef.current)
		// console.log("widht", widthWindos)
		if(itemsHeadRef){
			setHeigthHead(0)
			// console.log("Elementos Head 2", itemsHeadRef)
			// console.log("Elementos Head 2 Current", itemsHeadRef.current)
			const valuesHeightHead = []
			// console.log(valuesHeightHead)
			// console.log(Object.keys(itemsHeadRef.current).forEach(function(key, index) {
			// 	console.log("key y index", key, index) 
			// }))
			Object.keys(itemsHeadRef.current).forEach(function(key, index) {
				// console.log("heigth Head" + index + " " + key, itemsHeadRef.current[key]?.clientHeight)
				// console.log("heigth Head off" + index + " " + key, itemsHeadRef.current[key]?.offsetHeight)
				valuesHeightHead[index] = itemsHeadRef.current[key]?.offsetHeight
			})
			
			// console.log("Values pure", valuesHeightHead)
			// console.log("heigth head", Math.max(valuesHeightHead.filter(element => element !== undefined)))
			
			setHeigthHead(Math.max(...valuesHeightHead.filter(element => element !== undefined)))
			// console.log(Math.max(...valuesHeightHead.filter(element => element !== undefined)))
		}
		// console.groupEnd()
	}

	const minHeightForPrice = () => {
		if(itemsPriceRef){
			setHeigthPrice(0)
			const valuesHeightPrice = []
			Object.keys(itemsPriceRef.current).forEach(function(key, index) {
				// console.log("heigth Price" + index + " " + key,itemsPriceRef.current[key]?.clientHeight)
				valuesHeightPrice[index] = itemsPriceRef.current[key]?.offsetHeight 
			})
			// console.log("heigth Price", Math.max(valuesHeightPrice.filter(element => element !== undefined)))
			setHeigthPrice( Math.max(...valuesHeightPrice.filter(element => element !== undefined)))
			// console.log(heigthPrice)
		}
	}
	
	//Primera carga el bloque head 
	useEffect(()=>{
		if(widthWindos >= 960){
			minHeightForHead()
		}else{
			// Retraso para primera vez que se carga en movil
			const timer = setTimeout(() => {
				minHeightForHead()
			}, 1000);
			return () => clearTimeout(timer);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	},[])

	// Para resize
	useEffect(()=>{
		minHeightForHead()
		// eslint-disable-next-line react-hooks/exhaustive-deps
	},[itemsHeadRef, widthWindos])

	//Primera carga el bloque Price
	useEffect(()=>{
		if(widthWindos >= 960){
			minHeightForPrice()
		}else{
			// Retraso para primera vez que se carga en movil
			const timer = setTimeout(() => {
				minHeightForPrice()
			}, 1000);
			return () => clearTimeout(timer);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	},[])

	// Para resize
	useEffect(()=>{
		minHeightForPrice()
		// eslint-disable-next-line react-hooks/exhaustive-deps
	},[itemsPriceRef, widthWindos])


	
    const modalModCompraRef = useRef()
    const openModalModCompra = () => modalModCompraRef.current.open()

	const onClickRequest = () => {
        console.log('Contratar')
        openModalModCompra()
    }




	let titlestyle = fc_COLOR_CAJA ? fc_COLOR_CAJA : 'amarillo';
	return (
		<>
		<div className={'cPlanV2Wrap ' + titlestyle.toLowerCase()}>
			<div className="cPlanV2">
				<p className="cPlanV2Flag">{fc_TEXTO_CAJA}</p>
				<div 
					className="cPlanV2Head" 
					ref={refHead} 
					style={{minHeight: heigthHead + "px"}}
				>
					<div className='cPlanV2HeadClose' onClick={()=>onClickDelete(item)}>
						<i className='ico-x' />
					</div>
					<i className="cPlanV2Icon ico-smartphone"></i>
					<div className="cPlanV2HeadCont">
						<h3 className="h3">
							{fc_NOMBRE}  
							{/* {item.id} */}
						</h3>
						{ fc_DESCRIPCION &&
                            <p>
                                {fc_DESCRIPCION}
                            </p>
                    }
					</div>
				</div>
				<div 
					className="cPlanV2Prices" 
					ref={refPrice} 
					style={{minHeight: heigthPrice + "px"}}
				>
							{ fc_ETIQUETA_PERIODO &&
                                    <p className='cPlanV2PricesTitle'>
                                        {fc_ETIQUETA_PERIODO}
                                    </p>
                            }
							{
                                fi_PRECIO_PLAN &&
                                    <p className="cPlanV2PricesPrice">
                                        <span className="symbol"> $</span>
                                        <span className="cPrice">{<NumberFormat thousandSeparator={","} decimalSeparator={"."} displayType={'text'} value={Number.isInteger(fi_PRECIO_PLAN) ? fi_PRECIO_PLAN+".00" : fi_PRECIO_PLAN.toFixed(2)} />}</span>
                                        {/* <span className="sup"> .00</span> */}
                                    </p>
                            }
							{	fc_DESCRIPCION_OFERTA &&
                                    <p className="cPlanV2PricesTime">{fc_DESCRIPCION_OFERTA}</p>

                            }
							{	(fc_ETIQUETA_PRECIO_TACHADO && fc_PRECIO_TACHADO) &&

                                    <p className="cPlanV2PricesNote">{fc_ETIQUETA_PRECIO_TACHADO}: $ <del>{fc_PRECIO_TACHADO}</del></p>
                            }
							{ fc_NOTA_DEBAJO_PRECIO &&
                                    <p className="cPlanV2PricesPlaque">{Parser(fc_NOTA_DEBAJO_PRECIO)}</p>
                                    
                            }
				</div>
				<div className="cPlanV2Actions">
								{
                                    fc_TEXTO_CONTRATAR ?
                                        fc_OPCION_CONTRATACION === "URL" ?
                                            <a className="btn btnPrimario" href={fc_URL_CONTRATAR} target={fc_TARGET_CONTRATAR ? fc_TARGET_CONTRATAR : '_self'}>
                                                {
                                                fc_CRC === "postpago" || fc_CRC === "pospago" ? 'Contratar'
                                                : fc_TEXTO_CONTRATAR.replace('Ã¡', 'á')
                                                }
                                            </a>
                                            :
                                            <a className="btn btnPrimario" href="#!" onClick={() => onClickRequest()} target={'_self'}>
                                                {
                                                fc_CRC === "postpago" || fc_CRC === "pospago" ? 'Contratar'
                                                : fc_TEXTO_CONTRATAR.replace('Ã¡', 'á')
                                                }
                                            </a>
                                        : null
                                }
				</div>
			</div>
			<div className="cPlanV2Features">
				<div className="dtSpecial">
					<span className="iconCircle">
						<i className="ico-camera"></i>
					</span>
					<p>
						<strong>Excelente para navegar:</strong>
						<span>{exelentFor}</span>
					</p>
				</div>
				<dl>
					<dt>Datos Incluídos</dt>
					<dd>55 GB</dd>
				</dl>
				<dl>
					<dt>Minutos</dt>
					<dd>Ilimitados</dd>
				</dl>
				<dl>
					<dt>SMS</dt>
					<dd>Ilimitados</dd>
				</dl>
				<dl>
					<dt>Datos Incluídos</dt>
					<dd>Ilimitados</dd>
				</dl>
				<dl>
					<dt>Sin límite de Consumo</dt>
					<dd className="rs">
						<picture>
							<source type='image/webp' data-srcset={`${process.env.PUBLIC_URL}/assets/img/ico-rs-facebook.webp`}/>
							<source type='image/png' data-srcset={`${process.env.PUBLIC_URL}/assets/img/ico-rs-facebook.webp`}/>
							<img className="lazyload" alt='' width='25' height='25' data-src={`${process.env.PUBLIC_URL}/assets/img/ico-rs-facebook.png`}/>
						</picture>
						<picture>
							<source type='image/webp' data-srcset={`${process.env.PUBLIC_URL}/assets/img/ico-rs-facebook.webp`}/>
							<source type='image/png' data-srcset={`${process.env.PUBLIC_URL}/assets/img/ico-rs-facebook.webp`}/>
							<img className="lazyload" alt='' width='25' height='25' data-src={`${process.env.PUBLIC_URL}/assets/img/ico-rs-facebook.png`}/>
						</picture>
						<picture>
							<source type='image/webp' data-srcset={`${process.env.PUBLIC_URL}/assets/img/ico-rs-facebook.webp`}/>
							<source type='image/png' data-srcset={`${process.env.PUBLIC_URL}/assets/img/ico-rs-facebook.webp`}/>
							<img className="lazyload" alt='' width='25' height='25' data-src={`${process.env.PUBLIC_URL}/assets/img/ico-rs-facebook.png`}/>
						</picture>
						<picture>
							<source type='image/webp' data-srcset={`${process.env.PUBLIC_URL}/assets/img/ico-rs-facebook.webp`}/>
							<source type='image/png' data-srcset={`${process.env.PUBLIC_URL}/assets/img/ico-rs-facebook.webp`}/>
							<img className="lazyload" alt='' width='25' height='25' data-src={`${process.env.PUBLIC_URL}/assets/img/ico-rs-facebook.png`}/>
						</picture>
					</dd>
				</dl>
				<dl>
					<dt>Minutos LDI Incluídos</dt>
					<dd>Ilimitados USA, Cánada y México</dd>
				</dl>
				<dl>
					<dt>Incluye:</dt>
					<dd className="include">
						<picture>
							<source type='image/webp' data-srcset={`${process.env.PUBLIC_URL}/assets/img/logo-claro-musica-b.webp`}/>
							<source type='image/png' data-srcset={`${process.env.PUBLIC_URL}/assets/img/logo-claro-musica-b.webp`}/>
							<img className="lazyload" alt='' width='75' height='25' data-src={`${process.env.PUBLIC_URL}/assets/img/logo-claro-musica-b.png`}/>
						</picture>
					</dd>
				</dl>
			</div>
		</div>
		{
                fc_OPCION_CONTRATACION === "REN"
                    ?
                    <Modal
                        ref={modalModCompraRef}
                        size={ModalSize.MEDIUM_3}
                    >
                        <MModCompraPartModal
                            title={fc_TEXTO_CAJA}
                            name={fc_NOMBRE}
                            fc_DESCRIPCION={fc_DESCRIPCION}
                            fi_PRECIO_PLAN={fi_PRECIO_PLAN}
                            fc_ETIQUETA_PERIODO={fc_ETIQUETA_PERIODO}
                            fc_DESCRIPCION_OFERTA={fc_DESCRIPCION_OFERTA}
                            lstPlanContratacionxPlan={lstPlanContratacionxPlan}
                            symbolPrice={'$'}
                            Caracteristicas={Caracteristicas}
                            fc_TITULO_PROMO={fc_TITULO_PROMO}
                            caracteristicasPromocion={caracteristicasPromocion}
                        />
                    </Modal>
                    :
                    <Modal
                        ref={modalModCompraRef}
                        size={ModalSize.SMALL}
                    >
                        <MSolicitarPartModal
                            title={fc_TEXTO_CAJA}
                            name={fc_NOMBRE}
                            fc_DESCRIPCION={fc_DESCRIPCION}
                            fi_PRECIO_PLAN={fi_PRECIO_PLAN}
                            fc_ETIQUETA_PERIODO={fc_ETIQUETA_PERIODO}
                            lstPlanContratacionxPlan={lstPlanContratacionxPlan}
                            Caracteristicas={Caracteristicas}
                            optionsCiudades={optionsCiudadesLogic}
                            fi_PLAN={fi_PLAN}
                            fi_SERVICIO={fi_SERVICIO}
                        />
                    </Modal>
            }
		</>
	)
}

PlayComPlanCardMol.defaultProps = {
	item: {
		id: uuid(),
		title: "Titulo default",
		exelentFor: "Para los que navegan todo el día",
	},
	onClickDelete: ()=>{},
	refHead: [],
	refPrice: [],
	itemsHeadRef: [],
	itemsPriceRef: [],
	heigthHead: 0,
	heigthPrice: 0,
}
PlayComPlanCardMol.propTypes = {
	item: PropTypes.shape({
		title: PropTypes.string,
		exelentFor: PropTypes.string,
	}),
	onClickDelete: PropTypes.func,
}

export default PlayComPlanCardMol
